import React from "react";
import Select from "react-select";
import { onlyNumericInput, formatDate } from "@/utils";
import { originOptions, carYearOptions } from "@/constants/selectOptions";
import {
    useGetCarClassQuery,
    useGetCarGubunQuery,
    useGetCarManufacturerQuery,
    useGetCarModelDetailQuery,
    useGetCarModelQuery,
    useGetCarTrimQuery,
    useGetFuelListQuery,
} from "@/redux/metaApi";

export const AccidentInfo = ({ formData, handleChange, setFormData }) => {
    const { accidentCar } = formData;

    // 차종 옵션 (독립)
    const { data: carGubunData } = useGetCarGubunQuery();
    const carGubunOptions =
        carGubunData && carGubunData.data
            ? carGubunData.data.map((item) => ({
                  value: item.bgNo,
                  label: item.bgName,
              }))
            : [];

    // 제조사
    const { data: manufacturerData } = useGetCarManufacturerQuery({ bmNo: null });
    const manufacturerOptions =
        manufacturerData?.data?.map((item) => ({
            value: item.bmNo,
            label: item.bmName,
        })) || [];

    // 모델 (skip: !manufacturer)
    const { data: modelData } = useGetCarModelQuery({ bmNo: accidentCar?.bmNo }, { skip: !accidentCar?.bmNo });
    const modelOptions =
        modelData?.data?.map((item) => ({
            value: item.boiNo,
            label: item.boiName,
        })) || [];

    // 상세모델 (skip: !model)
    const { data: detailModelData } = useGetCarModelDetailQuery({ boiNo: accidentCar?.boiNo }, { skip: !accidentCar?.boiNo });
    const detailModelOptions =
        detailModelData?.data?.map((item) => ({
            value: item.boNo,
            label: item.boName,
        })) || [];

    // 등급 (skip: !detailModel)
    const { data: carClassData } = useGetCarClassQuery({ boNo: accidentCar?.boNo }, { skip: !accidentCar?.boNo });
    const carClassOptions =
        carClassData?.data?.map((item) => ({
            value: item.bsNo,
            label: item.bsName,
        })) || [];

    // 트림 (skip: !carClass)
    const { data: carTrimData } = useGetCarTrimQuery({ bsNo: accidentCar?.bsNo }, { skip: !accidentCar?.bsNo });
    const carTrimOptions =
        carTrimData?.data?.map((item) => ({
            value: item.bdNo,
            label: item.bdName,
        })) || [];

    // 유종 옵션 : getFuelList API
    const { data: fuelData } = useGetFuelListQuery();
    const fuelOptions =
        fuelData && fuelData.data
            ? fuelData.data.map((item) => ({
                  value: item.bfNo,
                  label: item.bfName,
              }))
            : [];

    return (
        <>
            {/* 차량번호 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        차량번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="accidentCar.carNumber"
                            placeholder=""
                            value={accidentCar?.carNumber || ""}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            {
                formData.orderId ? (
                    <>
                        <div className="item-row" data-grow="3">
                            <div className="row-head">
                    <span>
                        오더번호
                    </span>
                            </div>
                            <div className="row-content">
                                <div className="form-element">
                                    <input
                                        type="text"
                                        name="accidentCar.carNumber"
                                        placeholder=""
                                        value={formData.passedOrder?.serialNumber || ""}
                                        onChange={handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-row" data-grow="3"></div>
                    </>
                ) : (
                    <>
                        <div className="item-row" data-grow="3"></div>
                        <div className="item-row" data-grow="3"></div>
                    </>
                )
            }


            {/* 국산/수입 선택 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        국산/수입 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={originOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="국산/수입 선택"
                            value={originOptions.find((opt) => opt.value === accidentCar?.cho)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        cho: option.value,
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 차종 (독립) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        차종 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            options={carGubunOptions}
                            isSearchable
                            placeholder="차종 선택"
                            value={carGubunOptions.find((opt) => opt.label === accidentCar?.carGubun)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        carGubun: option.label,
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 제조사 (독립; 제조사 선택 시 하위 초기화) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        제조사 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="제조사 선택"
                            options={manufacturerOptions}
                            value={manufacturerOptions?.find((opt) => opt.value === accidentCar?.bmNo)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        bmNo: option.value,
                                        boiNo: "",
                                        boNo: "",
                                        bsNo: "",
                                        bdNo: "",
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* 모델 (제조사 선택에 종속) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        모델 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="모델 선택"
                            options={modelOptions}
                            value={modelOptions?.find((opt) => opt.value === accidentCar?.boiNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        boiNo: option.value,
                                        boNo: "",
                                        bsNo: "",
                                        bdNo: "",
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 상세모델 (모델 선택에 종속) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>상세모델</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="상세모델 선택"
                            options={detailModelOptions}
                            value={detailModelOptions?.find((opt) => opt.value === accidentCar?.boNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        boNo: option.value,
                                        bsNo: "",
                                        bdNo: "",
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 등급 (상세모델 선택에 종속) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>등급</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="등급 선택"
                            options={carClassOptions}
                            value={carClassOptions?.find((opt) => opt.value === accidentCar?.bsNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        bsNo: option.value,
                                        bdNo: "",
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 트림 (등급 선택에 종속) */}
            {/* <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>트림</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="트림 선택"
                            options={carTrimOptions}
                            value={carTrimOptions?.find((opt) => opt.value === accidentCar?.bdNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...accidentCar,
                                        bdNo: option.value,
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div> */}

            {/* 연식 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>연식</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="연식 선택"
                            options={carYearOptions}
                            value={carYearOptions?.find((opt) => opt.value === accidentCar?.firstDate)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...prev.accidentCar,
                                        firstDate: option.value,
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 배기량 */}
            {/* <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>배기량(cc)</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="배기량 선택"
                            options={displacementOptions}
                            value={displacementOptions?.find((opt) => opt.value === accidentCar?.displacement)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    accidentCar: {
                                        ...prev.accidentCar,
                                        displacement: option.value,
                                    },
                                }))
                            }
                        />
                    </div>
                </div>
            </div> */}
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>
        </>
    );
};
